import React, { forwardRef } from "react";
import SectionHeader from "./Section/SectionHeader";
import Section from "./Section/Section";

const About = forwardRef((props, ref) => {
  return (
    <Section id="about" ref={ref} borderTopBottom>
      <SectionHeader
        reverse
        title={"About Us"}
        content={"Lorem ipsum dolor sit amet, consectetur adipisicing elit."}
      >
        <h3 className="text-3xl font-serif font-bold text-indigo-900">
          Find the <span className="font-bold text-orange-600">best way</span>
          to create a successful project
        </h3>
      </SectionHeader>
      <div className="grid grid-cols-2 col-span-3 gap-8 bgRound relative">
        <figure className="mt-32 rounded-lg overflow-hidden shadow-lg">
          <img src="/assets/about01.webp" alt="" />
        </figure>
        <figure className="mb-32 rounded-lg overflow-hidden shadow-lg">
          <img src="/assets/about02.webp" alt="" />
        </figure>
        <div>
          <img
            className="animate-bounce absolute w-16 h-16 top-[1.2437810945%] left-[14.9082568807%]"
            src="/assets/icon_data2x.webp"
            alt="data"
          />
          <img
            className="animate-bounce absolute w-16 h-16 top-[57.2139303483%] left-[44.7247706422%]"
            src="/assets/icon_share2x.webp"
            alt="share"
          />
          <img
            className="animate-bounce absolute w-16 h-16 top-[-7.4626865672%] right-[1.1467889908%]"
            src="/assets/icon_shield2x.webp"
            alt="shield"
          />
        </div>
      </div>
    </Section>
  );
});

export default About;
